import { store } from '@/store'
import { forceSearchParamsLoader } from '../utils'
import { companyApi } from '@/store/services'

export const CompanyListLoader = (args) => {
  const initial = {
    page: 1,
    per_page: 10,
    'order[field]': 'created_at',
    'order[sort]': 'desc'
  }
  return forceSearchParamsLoader({ initial, args }, (searchParams) => store.dispatch(
    companyApi.endpoints.getCompanies.initiate(`?${searchParams}`)
  ).unwrap())
}

export const CompanyEditLoader = (args) => {
  const { params } = args

  return store
    .dispatch(
      companyApi.endpoints.getCompany.initiate(params.id)
    )
    .unwrap()
}
